import React, { useState } from 'react';
import LanguageSelector from '../LanguageSelector';
import { useLanguage } from '../LanguageContext';

const ResturantSec = (props) => {
    const { state } = useLanguage();
	const { language } = state;

    return (
        <section className="rastaurant-section mb-155">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 pr-0">
                        <div className="rastaurant-left"></div>
                    </div>
                    <div className="col-lg-6 pl-0">
                        <div className="rastaurant-right pt-240 pb-250 rpt-140 rpb-150">
                            <div className="ras-content pl-70">
                                <h2 className="border-text">{language === 'ar' ? 'نبني عالمك' : 'Buildings'}</h2>
                                <h2 className="text-white">{language === 'ar' ? 'تميز' : 'Excellence'}<br/>{language === 'ar' ? 'ابداع' : 'creativity'} <br/>{language === 'ar' ? 'التزام' : 'Commitment'}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </section>
    )
}

export default ResturantSec;